<script lang="ts">
  import { POWER_UP_INFO } from '../content/power-ups';
  import { powerUpTileStyle, type EffectStatus } from './chaos';

  /** Compact strip of the effects on this player with seconds left, plus a held shield. */
  interface Props {
    effects: readonly EffectStatus[];
    shield: boolean;
  }
  let { effects, shield }: Props = $props();
</script>

<div class="chaos-status" role="status" aria-label="Active power-ups">
  {#if shield}<span
      class="effect shield"
      title={POWER_UP_INFO.shield.title}
      style={powerUpTileStyle('shield')}
    ></span>{/if}
  {#each effects as effect (effect.kind)}
    <span class="effect" title={POWER_UP_INFO[effect.kind].title} style={powerUpTileStyle(effect.kind)}>
      <b>{Math.ceil(effect.remainingMs / 1000)}</b>
    </span>
  {/each}
</div>

<style>
  .chaos-status {
    margin: calc(-1 * var(--game-gap, 16px) + 4px) 0 0;
    display: flex;
    justify-content: center;
    gap: 8px;
    min-height: 22px;
  }
  /* Each chip wears the kind's tile treatment, so it reads as the tile that caused it. */
  .effect {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: var(--theme-chip-radius);
    background: var(--pu-background);
    background-size: var(--pu-background-size);
    color: var(--pu-text);
    border: var(--pu-border);
    font-size: 13px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .effect::before {
    content: var(--pu-glyph);
    color: var(--pu-glyph-color);
  }
</style>
